function Name() {
    return (
        <div>
            <h1 className="home-hero hero-text">Welcome to Raw-Bean&trade;</h1>
            <h5 className="hero-text">I’m Reymond. This is my personal space in the vastness of the internet.</h5>
        </div>
    )
}

export default Name